<template>
  <div class="alive-nav-content">
    <div class="left">
      <div
        v-for="tag in visitedTabsView"
        :key="tag.path"
        class="tags-view-item"
        @click="go(tag.path)"
      >
        <div class="tag flex_c_c" :class="[{ active: isActive(tag) }]">
          <span>{{ tag.name }}</span>
          <span class="closebox flex_c_c" @click.stop="handleClose(tag)">
            <svg-icon
              iconClass="close"
              className="icon"
              @iconClick="handleClose(tag)"
            />
          </span>
        </div>
      </div>
    </div>
    <div class="opt">
      <div style="display: flex">
        <div class="item" title="刷新" @click="reload">
          <i style="font-size: 20px;color:#fff" class="el-icon-refresh-right" />
        </div>
        <div class="item" @click="drawer = true">
          <i style="font-size: 20px;color:#fff" class="el-icon-user" />
        </div>
      </div>
    </div>
    <upcome-drawer></upcome-drawer>
    <message-drawer></message-drawer>
    <UserDrawer :drawer="drawer" @close="drawer = false" @exit="exit"></UserDrawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MessageDrawer from './MessageDrawer.vue'
import UpcomeDrawer from './UpcomeDrawer.vue'
import UserDrawer from './UserDrawer.vue'
import { logout } from '@/api/system'
export default {
  components: { UpcomeDrawer, MessageDrawer, UserDrawer },
  data() {
    return {
      // topArrow: false
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'addressDropOption', 'isNewMeg', 'isNewUpcome', 'visitedTabsView']),
    country() {
      const label = this.addressDropOption?.find(a => a.value === this.userInfo?.countryId)?.label
      return label
    }
  },
  watch: {
    $route() {
      this.addTabsView()
    }
  },
  created() {
    console.log('this.$route.path', this.$route.path)
    this.addTabsView()
  },
  mounted() {
    if (!this.userInfo) {
      this.$store.dispatch('getUserInfo')
    }
    if (!this.addressDropOption) {
      this.$store.dispatch('getAddress')
    }
  },
  methods: {
    ...mapActions(['addVisitedTabsView', 'delVisitedTabsView']),
    showUpComing() {
      this.$store.commit('SET_ISNEWUPCOME', false)
      this.$store.commit('CHANGE_UPCOME_DRAWER', true)
    },
    showMessage() {
      this.$store.commit('SET_ISNEWMSG', false)
      this.$store.commit('CHANGE_MESSAGE_DRAWER', true)
    },
    doc() {
      const { doc } = this.$route.meta
      window.open(`https://ccs.feepower.com/doc/basic/${doc}`)
    },
    // enterUser() {
    //   this.topArrow = true
    // },
    // leaveUser() {
    //   this.topArrow = false
    // },
    async exit() {
      const res = await logout()
      if (res.success) {
        this.$store.commit('USER_SET', '')
        this.$store.commit('ADD_INITROUTER', [])
        this.$store.commit('RESET_TABSVIEW', [])
        sessionStorage.removeItem('userInfo')
        this.$router.push('/')
        window.location.reload()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    reload() {
      const parentDom = this.$parent
      const childList = parentDom.$children
      childList.forEach(vnode => {
        // console.log(vnode.$vnode)
        if (vnode.$vnode.tag.indexOf(this.$route.name) > -1) {
          if (vnode.$vnode.componentInstance.refresh) {
            // this.removeKeepAliveCacheForVueInstance(this, this.$route.meta.componentName)
            vnode.$vnode.componentInstance.refresh()
            this.$nextTick(() => {
              this.$message.success('当前页面数据已刷新')
            })
          }
        }
      })
    },
    addTabsView() {
      if (this.visitedTabsView.length > 9) {
        // this.$message.warning('页签最多10个')
        this.handleClose(this.visitedTabsView[0])
      }
      const route = this.generateRoute()
      console.log('route', route)
      if (!route) {
        return false
      }
      this.addVisitedTabsView(this.generateRoute())
    },
    generateRoute() {
      if (this.$route.meta.title) {
        return this.$route
      }
      return false
    },
    isActive(route) {
      return route.path === this.$route.path || route.name === this.$route.name
    },
    go(path) {
      const query = this.$route.query
      if (query.menuCode) {
        this.$confirm('当前文档未保存，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(() => {
            this.$router.push(path)
          })
          .catch(() => {})
      } else {
        this.$router.push(path)
      }
    },
    handleClose(tag) {
      this.delVisitedTabsView(tag).then((tags) => {
        // 如果关闭的是当前显示的页面，就去到前一个 tab-view 页面
        if (this.isActive(tag)) {
          const lastTag = tags.slice(-1)[0]
          // 前一个 tab-view 页面存在，就跳；不存在就到首页
          if (lastTag) {
            this.$router.push(lastTag.path)
          } else {
            this.$message.warning('最后一个标签不能删除')
          }
        }
        this.removeKeepAliveCacheForVueInstance(this, tag.componentName)
      })
    },
    removeKeepAliveCacheForVueInstance(vueInstance, componentName) {
      const parentDom = vueInstance.$parent
      const childList = parentDom.$children
      childList.forEach(vnode => {
        if (vnode.$vnode.tag.indexOf(componentName) > -1) {
          const key = vnode.$vnode.parent.componentInstance.keyToCache
          const cache = vnode.$vnode.parent.componentInstance.cache
          const keys = vnode.$vnode.parent.componentInstance.keys
            if (cache[key]) {
              vnode.$destroy()
              delete cache[key]
              const index = keys.indexOf(key)
              if (index > -1) {
                keys.splice(index, 1)
              }
            }
        }
      })
      this.$store.commit('SET_CREATE_TAB', { type: 'order', bool: false })
    }
  }
}
</script>

<style lang="less" scoped>
.alive-nav-content {
  width: 100%;
  height: 40px;
  margin: 5px 0;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
  }
  .tags-view-item {
    & + .tags-view-item {
      margin-left: 10px;
    }
  }
  .reload {
    position: absolute;
    z-index: 999;
    width: 30px;
    height: 30px;
    background: #F7F7F7;
    border-radius: 15px;
    right: 20px;
    cursor: pointer;
  }
  .tag {
    height: 30px;
    background: #f7f7f7;
    border-radius: 2px;
    padding: 0 0 0 8px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    box-sizing: border-box;
    cursor: pointer;
    .closebox {
      height: 100%;
      padding: 0 8px 0 8px;
      box-sizing: border-box;
    }
    .icon {
      font-size: 14px;
      cursor: pointer;
      &:hover {
        color:  rgb(18,88,188);
      }
    }
  }
  .active {
    color:  rgb(18,88,188);
  }
  .opt {
    display: flex;
    align-items: center;
    margin-right: 20px;
    .item {
      width: 30px;
      height: 30px;
      background: rgb(48, 65, 86);
      margin-top: 5px;
      border-radius: 15px 15px 15px 15px;
      cursor: pointer;
      padding: 5px;
      box-sizing: border-box;
      position: relative;
      & + .item {
        margin-left: 10px;
      }
      img {
        width: 20px;
        height: 20px;
      }
      .new-info {
        width: 12px;
        height: 12px;
        background: #FE453D;
        border-radius: 50%;
        opacity: 1;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 16px;
      }
    }
    .user {
      display: flex;
      justify-content: space-between;
      width: 30px;
      margin-left: 10px;
      cursor: pointer;
    }
    :deep(.el-input__inner) {
      height: 30px;
      line-height: 30px;
      border-radius: 5px 0 0 5px;
    }
    .btn {
      padding: 4px 12px;
      height: 30px;
      border-radius: 0px 5px 5px 0px;
    }
    .avatar {
      width: 30px;
      height: 30px;
      background: #FFFFFF;
      margin-top: 5px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 30px;
        height: 30px;
      }
    }
    .icon {
      line-height: 40px;
      color: #fff;
      transition: all .5s;
    }
    .deg {
      transform: rotate(180deg);
    }
  }
}
</style>
